import * as Yup from 'yup';

import {
  yupMaxField,
  yupMinField,
  yupRequiredField,
} from '../../../../../utils/helpers/yup';
import { SortingMachinesType } from '../../SortingMachine.functions';


export type Coordinates = [number, number];

export type CreateSortingMachinesType = {
  hubId: number;
  hubName?: string;
  name: string;
  maxPorts: number;
  employeeId: number | null;
  employeeName?: string,
};

export function getDefaultValues(
  isEditDialog: boolean,
  sortingMachine: SortingMachinesType | undefined
): CreateSortingMachinesType {
  return {
    hubId: isEditDialog ? sortingMachine?.hubId ?? 0 : 0,
    hubName: isEditDialog ? sortingMachine?.hubName ?? '' : '',
    name: isEditDialog ? sortingMachine?.name ?? '' : '',
    maxPorts: isEditDialog ? sortingMachine?.maxPorts ?? 1 : 1,
    employeeId: isEditDialog ? sortingMachine?.employeeId ?? null : null,
    employeeName: isEditDialog ? sortingMachine?.employeeName ?? '' : ''
  };
}

export function getValidationSchema(t: any) {
  return Yup.object().shape({
    hubId: Yup.number()
      .required(yupRequiredField(t, t('Hub')))
      .min(1, ({ min }) => yupMinField(t, t('Hub'), min)),
    name: Yup.string()
      .required(yupRequiredField(t, t('Name')))
      .min(2, ({ min }) => yupMinField(t, t('Name'), min))
      .max(50, ({ max }) => yupMaxField(t, t('Name'), max)),
    hubName: Yup.string().optional(),
    maxPorts: Yup.number()
      .required(yupRequiredField(t, t('Max Ports')))
      .min(1, ({ min }) => yupMinField(t, t('Max Ports'), min))
      .max(50, ({ max }) => yupMaxField(t, t('Max Ports'), max)),
    employeeId: Yup.number().optional().nullable(),
    employeeName: Yup.string().optional(),
  });
}

export function toApiData(values: CreateSortingMachinesType) {
  let apiData: CreateSortingMachinesType = {
    ...values,
  };

  apiData.hubId = parseInt(values.hubId.toString(), 10);
  apiData.name = values.name.trim();
  apiData.maxPorts = parseInt(values.maxPorts.toString(), 10);


  if (apiData.hubName) {
    delete apiData.hubName;
  }

  delete apiData.employeeName;
  return apiData;
}
